import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getFormData = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-data`);
    return response.data;
  } catch (error) {
    console.error('Error fetching form-data:', error.response?.data || error);
    throw error;
  }
};

export const getFormDataByWorkOrderFormId = async (workOrderFormId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-data`, {
      params: { workOrderFormId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching form-data:', error.response?.data || error);
    throw error;
  }
};

export const getFormDataByWorkOrderFormIds = async (workOrderFormIds = []) => {
  if (!workOrderFormIds.length) {
    return [];
  }

  try {
    const response = await axiosInstance.get(
      `${API_URL}/form-data/by-work-order-ids`,
      {
        params: { workOrderFormId: workOrderFormIds },
        paramsSerializer: {
          serialize: (params) => {
            const query = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                value.forEach((entry) => {
                  query.append(key, String(entry));
                });
                return;
              }
              query.append(key, String(value));
            });
            return query.toString();
          },
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching form-data:', error.response?.data || error);
    throw error;
  }
};

export const getFormDataById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-data/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching form-data:', error.response?.data || error);
    throw error;
  }
};

export const createFormData = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/form-data`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating form-data:', error.response?.data || error);
    throw error;
  }
};

export const updateFormData = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/form-data/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating form-data:', error.response?.data || error);
    throw error;
  }
};

export const deleteFormData = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/form-data/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting form-data:', error.response?.data || error);
    throw error;
  }
};
